import { NgSelectComponent } from '@ng-select/ng-select';

/**
 * Global configuration to restrict all ng-select instances from
 * clearing or unselecting selected items when backspace is pressed.
 */
(NgSelectComponent.prototype as any)._handleBackspace = function () {
  // Globally disabled: do not clear or unselect items on backspace
  return;
};
